<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Highlight Label"
    seFeDataSubtitle="a label with a highlighted background color"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>This is currently used only in the Household Setup app.
          There are 2 options for theme: adult, child.
        </p>
      </se-fe-card-content>
    </se-fe-card>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example"></se-fe-card-header>
      <se-fe-card-content>
        <div>
          <se-po-highlight-label
            label="This is a label for My Child"
            theme="child">
          </se-po-highlight-label>
        </div>
        <div style="margin-top: 24px;">
          <se-po-highlight-label
            label="This is a label for Myself or another adult"
            theme="adult">
          </se-po-highlight-label>
        </div>

        <se-fe-docs-code [code]="html" lang="html"></se-fe-docs-code>

      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
